















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { AttachmentType } from '@/models/fixedops/attachment';
import { Base } from '@/components/common/base';
import { attachmentTypeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class AddAttachmentTypePage extends Base {
  public attachmentType: AttachmentType = {
    name: '',
    description: '',
  };
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  // public attachmentService: AttachmentService;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public disableSubmitButton: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({ name: 'admin.attachmenttypes' });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.submitAttachmentType();
    }
    this.resetMethodName(methodName);
  }

  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('attachmentTypes.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('attachmentTypes.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'attachmentType');

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setFields();
    if (this.$route.params.id) {
      this.getAttachmentType(this.$route.params.id);
    }
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t('attachmentTypes.attachmentTypeFields.name') as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Name', v),
            v => this.alphaSpace(v)
          ]
        },
      },
      {
        key: 'description',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 250,
          label: this.$t(
            'attachmentTypes.attachmentTypeFields.description'
          ) as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Name', v),
          ]
        },
      },
    ];
  }

  public async getAttachmentType(id: string) {
    try {
      this.formlyShowSkeleton(this.formFields);
      this.attachmentType = await attachmentTypeService.getAttachmentTypeByIdAsync(
        Number(id)
      );
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public validateAttachmentType(): Vue & { validate: () => boolean } {
    return this.$refs.attachmentTypeForm as Vue & { validate: () => boolean };
  }

  public async submitAttachmentType(): Promise<void> {
    if (this.validateAttachmentType().validate()) {
      var validateRes = this.$validator.errors.items.length > 0;
      if (validateRes) {
        this.showAlert(false, 'Please Enter Valid Details');
        return;
      }

      try {
        // this.showLoader();
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        if (this.$route.params.id) {
          await attachmentTypeService.updateAttachmentAsync(this.attachmentType);
          this.showAlert(
            true,
            this.$t('attachmentTypes.alertUpdateAttachmentType')
          );
          this.$router.push({
            name: 'admin.attachmenttypes',
            params: {
              tenantId: this.$route.params.tenantId,
              enterpriseId: this.$route.params.enterpriseId,
            },
          });
        } else {
          await attachmentTypeService.saveAttachmentTypeAsync(
            this.attachmentType
          );
          this.showAlert(
            true,
            this.$t('attachmentTypes.alertSaveAttachmentType')
          );
          this.$router.push({
            name: 'admin.attachmenttypes',
            params: {
              tenantId: this.$route.params.tenantId,
              enterpriseId: this.$route.params.enterpriseId,
            },
          });
        }
      } finally {
        // this.hideLoader();
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }
}
